import en from './en'
import Utils from '../Utils'

var enMsg = {
  'agreements.title': 'Agreements',
  'agreements.error.mandatory': "You need to agree to continue using deeper services",
  'agreements.error.blank': "Please make a choice",
  'agreements.back': 'Back',
  'agreements.agree': 'Agree',
  'agreements.decline': 'Decline',
  'agreements.text.full': 'Full agreement'
}

Utils.addTerms(enMsg, en)

export default enMsg



// WEBPACK FOOTER //
// ./src/lang/enMsg.js